module.exports = __webpack_public_path__ + "static/vinay-solo-new-db9fb5a6ecc41ca9a9e395fc87acfb1d.jpg";